<div class="row">
    <div class="title">Заголовок</div>
    <input [(ngModel)]="news.title">
</div>
<div class="row">
    <div class="title">Изображение</div>
    <input type="file" [(ngModel)]="news.picture">
</div>
<div class="row">
    <div class="title">Контент</div>
    <textarea [(ngModel)]="news.content" rows="10"></textarea>
</div>
<div class="row">
    <div class="title">URL</div>
    <input [(ngModel)]="news.url">
</div>

<div class="row">
</div>

<div class="row">
    <div class="title"></div>
    <button (click)="create()">Создать</button>
</div>
